// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Retailer/index.css
// module id = 1736
// module chunks = 0